<template>
    <v-image :config="config_image"></v-image>
</template>

<script>
    export default {
        name: "BaseImage",
        props: ['img', 'scale', 'left_margin', 'top_margin'],
        computed: {
            config_image: _this => (
                !_this.img ? {} : {
                    x: _this.left_margin,
                    y: _this.top_margin,
                    image: _this.img,
                    width: _this.img.width,
                    height: _this.img.height,
                    scaleX: _this.scale || 1,
                    scaleY: _this.scale || 1,
                    globalCompositeOperation: 'destination-over',
                    hitFunc: () => {}
                }
            )
        },
    }
</script>

<style scoped>

</style>
